import { useEffect, useRef } from "react";

export default function useUnsavedSurveyWarning({ dirty, history }) {
  const unblockRef = useRef(null);

  useEffect(() => {
    const unblock = history.block(() => dirty ? "Discard unsaved survey changes?" : undefined);
    unblockRef.current = unblock;
    const beforeUnload = (event) => {
      if (!dirty) return;
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", beforeUnload);
    return () => {
      unblock();
      window.removeEventListener("beforeunload", beforeUnload);
    };
  }, [dirty, history]);

  return unblockRef;
}
